import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { LocalSaveService } from '../app/services/local-save-service.service';
import 'rxjs/add/operator/do';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private localSave: LocalSaveService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add auth token if available
    let authReq = req;
    const token = this.localSave.get('OSR_TKN');

    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `p ${token}`
        }
      });
    }

    return next.handle(authReq).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Request completed successfully
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          switch (err.status) {
            case 401:
              // Unauthorized — clear session and redirect to login
              this.localSave.clear();
              this.router.navigate(['/login']);
              break;
            case 403:
              // Forbidden — user lacks permissions
              break;
            case 429:
              // Too Many Requests — rate limit reached
              alert('Demasiadas solicitudes. Por favor espere unos minutos e intente de nuevo.');
              break;
            case 0:
              // Network error — server unreachable
              break;
            default:
              break;
          }
        }
      }
    );
  }
}
